/* ================================================
   modal-manager.js - ALLE MODALS IN EINER DATEI
   Vollständig geschützt gegen Mehrfachladung
   ================================================ */

(function() {
  'use strict';
  
  // ============================================================
  // SCHRITT 1: ModalManager (nur einmal initialisieren)
  // ============================================================
  
  if (typeof window.ModalManager === 'undefined') {
    
    window.ModalManager = (function() {
      let instance = null;

      class ModalManagerClass {
        constructor() {
          if (instance) {
            return instance;
          }
          
          this.activeModal = null;
          this.newsletterResetFlag = false;
          instance = this;
        }

        static getInstance() {
          if (!instance) {
            instance = new ModalManagerClass();
          }
          return instance;
        }

        canShow(modal) {
          return this.activeModal === null || this.activeModal === modal;
        }

        register(modal) {
          if (this.canShow(modal)) {
            this.activeModal = modal;
            return true;
          }
          return false;
        }

        unregister(modal) {
          if (this.activeModal === modal) {
            this.activeModal = null;
            
            if (this.newsletterResetFlag) {
              this.newsletterResetFlag = false;
              this.startNewsletterTimer();
            }
          }
        }

        resetNewsletterTimer() {
          const newsletterModal = document.querySelector('newsletter-modal');
          if (newsletterModal) {
            newsletterModal.resetTimer();
            this.newsletterResetFlag = true;
          }
        }

        startNewsletterTimer() {
          const newsletterModal = document.querySelector('newsletter-modal');
          if (newsletterModal && newsletterModal.canStillShow()) {
            newsletterModal.startTimer();
          }
        }
      }

      return ModalManagerClass;
    })();
  }

  // ============================================================
  // SCHRITT 2: Newsletter Modal
  // ============================================================
  
  if (!customElements.get('newsletter-modal')) {
    
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
        this.modalManager = window.ModalManager.getInstance();
        this.timerID = null;
        this.originalDelay = null;

        if (this.hasCustomerPurchased()) return;
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) return;
        
        if (theme.config.isTouch) {
          new theme.initWhenVisible(this.init.bind(this));
        } else {
          this.init();
        }
      }

      get shouldLock() { return true; }
      get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
      get delay() { return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5; }
      get expiry() { return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30; }
      get cookieName() { return 'concept:newsletter-popup'; }
      get submited() { return this.querySelector('.alert') !== null; }

      init() {
        this.originalDelay = this.delay;
        if (this.submited) {
          this.attemptShow();
          return;
        }
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.startTimer();
        }
      }

      startTimer() {
        this.clearTimer();
        if (Shopify && Shopify.designMode) return;
        
        this.timerID = setTimeout(() => {
          this.attemptShow();
        }, this.originalDelay * 1000);
      }

      clearTimer() {
        if (this.timerID) {
          clearTimeout(this.timerID);
          this.timerID = null;
        }
      }

      resetTimer() {
        this.clearTimer();
      }

      attemptShow() {
        if (this.modalManager.canShow(this)) {
          this.modalManager.register(this);
          this.show();
        }
      }

      canStillShow() {
        return !this.getCookie(this.cookieName) || this.testMode;
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
        this.modalManager.unregister(this);
        
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
        this.setCookie(this.cookieName, this.expiry);
      }

      hasCustomerPurchased() {
        return this.getCookie('has_purchased') !== null;
      }
      
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }

    customElements.define('newsletter-modal', NewsletterModal);
  }

  // ============================================================
  // SCHRITT 3: Exit Intent Modal
  // ============================================================
  
  if (!customElements.get('exit-intent-modal')) {
    
    class ExitIntentModal extends ModalElement {
      constructor() {
        super();
        this.modalManager = window.ModalManager.getInstance();

        if (this.hasCustomerPurchased()) return;
        if (window.location.pathname === '/challenge') return;
        if (!theme.cookiesEnabled) return;

        this.perSession = this.dataset.perSession === 'true';
        this.init();
        if (!this.testMode && this.hasBeenShown()) return;

        if (theme.config.isTouch) {
          this.initMobileTriggers();
        } else {
          this.initDesktopTrigger();
        }
      }

      get shouldLock() { return true; }
      get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry'), 10) : 30;
      }

      get cookieName() { return 'concept:exit-intent-popup'; }
      get sessionStorageKey() { return 'concept:exit-intent-popup-session'; }
      get activityReadyKey() { return 'concept:exit-intent-activity-ready'; }
      get submited() { return this.querySelector('.alert') !== null; }

      get mobileActivityDelay() {
        return parseInt(this.dataset.mobileActivityDelay || '10', 10) * 1000;
      }
      get mobileInactivityDelay() {
        return parseInt(this.dataset.mobileInactivityDelay || '30', 10) * 1000;
      }
      get fastScrollThreshold() {
        return parseInt(this.dataset.fastScrollThreshold || '500', 10);
      }
      get fastScrollTimeWindow() {
        return parseInt(this.dataset.fastScrollTimeWindow || '2000', 10);
      }

      init() {
        if (this.submited) {
          this.show();
          return;
        }
      }

      initDesktopTrigger() {
        this._onMouseOut = this.handleMouseOut.bind(this);
        document.addEventListener('mouseout', this._onMouseOut, { passive: true });
      }

      handleMouseOut(e) {
        if (e.clientY > 0) return;
        this.attemptShow();
        this.cleanup();
      }

      initMobileTriggers() {
        this.lastActivity = Date.now();
        this.scrollHistory = [];
        this.triggersActive = false;

        if (sessionStorage.getItem(this.activityReadyKey) === 'true') {
          this.activateMobileTriggers();
        } else {
          setTimeout(() => {
            if (this.hasBeenShown()) return;
            sessionStorage.setItem(this.activityReadyKey, 'true');
            this.activateMobileTriggers();
          }, this.mobileActivityDelay);
        }
      }

      activateMobileTriggers() {
        if (this.triggersActive) return;
        this.triggersActive = true;

        this._onScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });

        this._onActivity = this.handleActivity.bind(this);
        ['touchstart', 'touchmove', 'scroll'].forEach(evt =>
          document.addEventListener(evt, this._onActivity, { passive: true }));

        this.startInactivityTimer();
      }

      handleScroll() {
        const now = Date.now();
        const y = window.scrollY;

        this.scrollHistory = this.scrollHistory.filter(
          entry => now - entry.time <= this.fastScrollTimeWindow
        );
        this.scrollHistory.push({ time: now, position: y });

        if (this.scrollHistory.length >= 2) {
          const distance = Math.abs(
            this.scrollHistory[this.scrollHistory.length - 1].position -
            this.scrollHistory[0].position
          );
          if (distance >= this.fastScrollThreshold) {
            this.attemptShow();
            this.cleanup();
          }
        }

        if (this.scrollHistory.length > 120) this.scrollHistory.shift();
      }

      handleActivity() {
        this.lastActivity = Date.now();
        this.startInactivityTimer();
      }

      startInactivityTimer() {
        if (this.inactivityTimer) clearTimeout(this.inactivityTimer);

        this.inactivityTimer = setTimeout(() => {
          const idle = Date.now() - this.lastActivity;
          if (!this.hasBeenShown() && idle >= this.mobileInactivityDelay) {
            this.attemptShow();
            this.cleanup();
          }
        }, this.mobileInactivityDelay);
      }

      attemptShow() {
        if (this.modalManager.canShow(this)) {
          this.modalManager.register(this);
          this.show();
        }
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
        this.modalManager.resetNewsletterTimer();
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
        this.modalManager.unregister(this);

        if (this.testMode) {
          this.removeShownFlag();
        } else {
          this.markAsShown();
        }
        this.cleanup();
      }

      cleanup() {
        if (this._onMouseOut)
          document.removeEventListener('mouseout', this._onMouseOut);
        if (this._onScroll)
          window.removeEventListener('scroll', this._onScroll);
        if (this._onActivity)
          ['touchstart', 'touchmove', 'scroll'].forEach(evt =>
            document.removeEventListener(evt, this._onActivity));
        if (this.inactivityTimer)
          clearTimeout(this.inactivityTimer);
      }

      hasBeenShown() {
        return this.perSession
          ? sessionStorage.getItem(this.sessionStorageKey) !== null
          : this.getCookie(this.cookieName) !== null;
      }

      markAsShown() {
        if (this.perSession)
          sessionStorage.setItem(this.sessionStorageKey, 'true');
        else
          this.setCookie(this.cookieName, this.expiry);
      }

      removeShownFlag() {
        if (this.perSession)
          sessionStorage.removeItem(this.sessionStorageKey);
        else
          this.removeCookie(this.cookieName);

        sessionStorage.removeItem(this.activityReadyKey);
      }

      hasCustomerPurchased() {
        return this.getCookie('has_purchased') !== null;
      }

      getCookie(name) {
        const m = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return m ? m[2] : null;
      }
      
      setCookie(name, days) {
        document.cookie = `${name}=true; max-age=${days * 86400}; path=/`;
      }
      
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }

    customElements.define('exit-intent-modal', ExitIntentModal);
  }

})();